// extracted by mini-css-extract-plugin
export default {"similar":"SummarySimilarCars__similar--yPxyu","car":"SummarySimilarCars__car--Qwo9u","image":"SummarySimilarCars__image--gwrZP"};